// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// hooks
import { useSellingPriceField } from './hooks/useSellingPriceField';

// consts/enums
import { DISCOUNT } from '../../constants';

// interstate
import { PlusCircleIcon } from '@interstate/components/Icons/PlusCircleIcon';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { Typography } from '@interstate/components/Typography';

// styles
import { dealerDiscountContainerStyle } from '../../dealSummary/common/ComponentLabelStyle';
import { StyledDealerDiscount, StyledDealerDiscountApplied } from './Terms.style';
import { Box } from '@interstate/components/Box';

type SellingPriceFieldWithDealerDiscounts = {
    toggleSlideOut?: () => void;
};

const SellingPriceFieldWithDealerDiscounts = (props: SellingPriceFieldWithDealerDiscounts) => {
    const { toggleSlideOut } = props;

    const showDealerDiscounts = typeof toggleSlideOut === 'function';
    const {
        label,
        discountTotal: discountTotalLabel,
        hasDiscountApplied,
        isItemizedDiscountsEnabledForDealer,
        isLocked,
        inputProps
    } = useSellingPriceField();

    const renderCompactDiscountCTA = () => {
        if (!showDealerDiscounts || !isItemizedDiscountsEnabledForDealer) return null;

        if (hasDiscountApplied) {
            return (
                <StyledDealerDiscountApplied
                    data-testid="add-dealer-discount-action"
                    onClick={toggleSlideOut}
                    component="button"
                    {...(isLocked && { disabled: true, className: 'disabled-button' })}
                >
                    <PlusCircleIcon aria-label="Dealer Discount" fontSize="small" />
                    <Typography variant={'body-xs'}>
                        {DISCOUNT}
                        {formatDollarsAndCents(discountTotalLabel * -1)}
                    </Typography>
                </StyledDealerDiscountApplied>
            );
        }

        return (
            <StyledDealerDiscount
                data-testid="add-dealer-discount-action"
                onClick={toggleSlideOut}
                component="button"
                {...(isLocked && { disabled: true, className: 'disabled-button' })}
            >
                <PlusCircleIcon aria-label="Dealer Discount" fontSize="small" />
                <Typography variant={'body-xs'}>{DISCOUNT}</Typography>
            </StyledDealerDiscount>
        );
    };

    return (
        <>
            {showDealerDiscounts ? (
                <div style={dealerDiscountContainerStyle} data-testid="selling-price-label">
                    <Typography variant={'body-xs'} color="#6d6d6d" sx={{ cursor: 'default', userSelect: 'none' }}>
                        {label}
                    </Typography>
                    {renderCompactDiscountCTA()}
                </div>
            ) : null}

            <Box style={{ marginTop: '-5.6px' }}>
                <NumericInput
                    {...(!showDealerDiscounts && { label })}
                    displayLabel={!showDealerDiscounts}
                    id="selling-price"
                    {...inputProps}
                />
            </Box>
        </>
    );
};

export default SellingPriceFieldWithDealerDiscounts;
